import React from 'react'

interface AmountFieldProps {
  value: string
}

const AmountField: React.FC<AmountFieldProps> = ({ value }) => {
  const display = value === '' ? "|" : value
  return (
    <div className="bg-transparent px-[clamp(12px,1.5vw,16px)] py-[clamp(8px,1vw,12px)] my-[clamp(12px,1.5vw,16px)] rounded-none w-full">
      <span 
        className={`text-black font-bold block text-center ${value === '' ? 'blink-caret' : ''}`}
        style={{ 
          fontSize: 'clamp(16px, 2.2vw, 26px)',
          direction: 'ltr',
          fontFamily: 'IBM Plex Sans Arabic, sans-serif'
        }}
      >
        {display}
      </span>
    </div>
  )
}

export default AmountField
